import { Component } from '@angular/core';
import { LoginService, LoginState } from 'pumpcalc-core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  loggedIn = false;
  preview=environment.preview;

  constructor(private loginService:LoginService) {
  }

  setLoggedIn(loginState) {
    this.loggedIn = loginState == LoginState.LOGGEDIN;
    if(this.loggedIn){this.loginService.startRefreshTokenCycle()}
  }

}

